import { render, staticRenderFns } from "./SignupVerified.vue?vue&type=template&id=2acdd63a&scoped=true&"
import script from "./SignupVerified.vue?vue&type=script&lang=ts&"
export * from "./SignupVerified.vue?vue&type=script&lang=ts&"
import style0 from "./SignupVerified.vue?vue&type=style&index=0&id=2acdd63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acdd63a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VCardTitle,VProgressLinear})
